import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class NewSearchWidgetQueryNextActionEvent extends BaseAnalyticsEvent {
  isMatchFound: NEW_SEARCH_WIDGET.ANALYTICS.RESULTS_FOR_SEARCH;
  searchTerm: String;
  endedWith: NEW_SEARCH_WIDGET.ANALYTICS.NEXT_ACTION;
  filteredSportType: Number;
  queryStatus: NEW_SEARCH_WIDGET.ANALYTICS.SEARCH_STATUS;

  constructor(params) {
    super('', 'query', 'search-tool');

    this.isMatchFound = params.isMatchFound;
    this.searchTerm = params.query;
    this.endedWith = params.endedWith;
    this.filteredSportType = params.filteredSportType;
    this.queryStatus = params.queryStatus;
  }

  get properties() {
    const properties = super.properties;

    properties.isMatchFound = this.isMatchFound;
    properties.searchTerm = this.searchTerm;
    properties.endedWith = this.endedWith;
    properties.filteredSportType = this.filteredSportType;
    properties.queryStatus = this.queryStatus;

    return properties;
  }


}
